module.exports = __webpack_public_path__ + "img/dodo.1b5b536b.png";